import React from "react";
import { GenericResponse } from "../CreateRound/CreateRoundModels";
import { QueryParams } from "../models/CouponShare";
import ItemSelect from "../Components/ItemSelect"
import { ListResponse } from "../api/ApiNgModels";
import { Sport } from "./LeagueModels";
import LeagueUtil from "./LeagueUtil";

interface SportSelectProps {
    value: number;
    disabled?: boolean;
    filter?: (item: Sport) => boolean;
    onChange: (item: Sport | undefined) => void;
    allItemEnabled: boolean;
    helperText?: string;
    error?: boolean;
}
const SportSelect: React.FC<SportSelectProps> = (props) => {
      
    const getSports = async (pageSize: number, lastId?: number) : Promise<GenericResponse<ListResponse<Sport>>> => {
        return await LeagueUtil.getSports();
    };


    const getId = (item?: Sport) : number => {
        return item ? item.id : 0;
    };
    const getIdString = (item?: Sport) : string => {
        return item ? item.id.toString() : "0";
    };
    const getName = (item?: Sport) : string => {
        return item ? item.name : "";
    };

    const onChange = (item?: Sport) : void => {
        if (props.onChange) {
            props.onChange(item);
        }
    };
  
    return (
        <ItemSelect<Sport, number>
            value={props.value}
            label="Sport"
            getId={getId}
            getIdString={getIdString}
            getName={getName}
            getItems={getSports}
            idFromString={s => s ? parseInt(s) : 0}
            onChange={onChange}
            disabled={props.disabled}
            filter={props.filter}
            getInfoText={it => it ? `Id: ${it.id} | Name:  ${it.name}` : ""}
            allItemEnabled={props.allItemEnabled}
            helperText={props.helperText}
            error={props.error}
    />
    );
};

export default SportSelect;
